export default __webpack_public_path__ + "static/media/python.b93a734c.svg";